import { ReactNode } from "react";

export type Props = {
  /** Whether to hide the signup link */
  hideSignupLink?: boolean;
  /** Render function for signup link */
  renderSignupLink?: () => ReactNode;
  /** Render function for forgot password link */
  renderForgotPasswordLink?: () => ReactNode;
  /** Container className */
  className?: string;
};

/**
 * Base login additional content component - unstyled, uses render props for flexibility.
 * Wrap with styled version in shared/features/auth.
 */
export function LoginAdditionalContentBase({
  hideSignupLink = false,
  renderSignupLink,
  renderForgotPasswordLink,
  className,
}: Props) {
  return (
    <div className={className} data-testid="login-additional-content">
      {!hideSignupLink && renderSignupLink?.()}
      {renderForgotPasswordLink?.()}
    </div>
  );
}

export default LoginAdditionalContentBase;

